import {Component, OnInit} from '@angular/core';
import {BaseService} from '../../base.service';
import {SliderService} from '../../services/slider.service';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {SliderDto} from '../../dto/slider.dto';
import { ContractsService } from '../../services/contracts.service';
import { Contract } from '../../models/contract';
import { multicast } from 'rxjs/operators';
import { environment } from '../../../environments/environment.local';
import { Env } from '../../env';
import { Property } from '../../models/property';
import { PropertyService } from '../../services/property.service';
import { DivisionService } from '../../services/division.service';
import { PaymentService } from '../../services/payment.service';
import { DivisionPItem } from '../../models/DivisionPItem';
import { PaymentPItem } from '../../models/paymentPItem';

//import { TabComponent  } from '../tabset/tab.component';

@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;
  property:Property;

  constructor(
    private baseService: BaseService,
    private service: DivisionService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private env: Env
  ) {}
  divisions:DivisionPItem[] = [];
  payments:PaymentPItem[] = [];

  paymentTotal = 10000000;
  paymentBigCurrentPage: number = 1;
  paymentMaxSize: number = 5;
  paymentsize: number = 10;
  paymentPage: number = 1;
  paymentStatus: string = '';

  ngOnInit() {
    this.titleComponent = 'Propiedad';
    this.titlePanel = 'Propiedades';
    this.baseService.changedComponentName(this.titleComponent);
    this.get();
  }


  get(){
    let id = this.route.snapshot.paramMap.get('id');
    this.service.get(id).subscribe( r => {
      console.log(r);


    } , err => {
      console.log(err);
    });
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/division/division.component.ts